import { ChevronRight } from 'lucide-react'

import { Money } from '@/components/ds'
import { EetStatusBadge } from '@/components/Eet/EetStatusBadge'
import { TableCell, TableRow } from '@/components/ui/table'
import { EetSubmission } from '@invo.space/shared'
import { Receipt } from '@invo.space/shared'

import { formatTime, lineLabel, receiptCurrency, receiptPaymentLabel, receiptSymbol, receiptTotal } from './receiptUtils'

interface ReceiptItemProps {
  receipt: Receipt
  eetSubmission?: EetSubmission
  showEet?: boolean
  onSelect?: (receipt: Receipt) => void
}

/** Řádek tabulky účtenek, klik otevře detail v panelu. */
export const ReceiptItem = ({ receipt, eetSubmission, showEet, onSelect }: ReceiptItemProps) => {
  const labels = receipt.receiptLines.map(lineLabel)
  const hasInvoice = receipt.references?.some((r) => r.targetType === 'invoice')

  return (
    <TableRow onClick={() => onSelect?.(receipt)} className="group cursor-pointer">
      <TableCell className="hidden md:table-cell">
        <p className="font-medium tabular">{receiptSymbol(receipt)}</p>
        <p className="text-xs text-muted-foreground tabular">{formatTime(receipt.issuedAt)}</p>
      </TableCell>
      <TableCell className="w-full max-w-0 md:w-auto">
        <p className="truncate">{labels.join(', ')}</p>
        <p className="truncate text-xs text-muted-foreground tabular md:hidden">
          {[
            receiptSymbol(receipt),
            formatTime(receipt.issuedAt),
            receiptPaymentLabel[receipt.paymentType] ?? receipt.paymentType,
          ]
            .filter(Boolean)
            .join(', ')}
        </p>
        <p className="hidden text-xs text-muted-foreground md:block">
          {labels.length} {labels.length === 1 ? 'položka' : labels.length < 5 ? 'položky' : 'položek'}
          {hasInvoice && ', vystavena faktura'}
        </p>
      </TableCell>
      <TableCell className="hidden text-muted-foreground md:table-cell">{receiptPaymentLabel[receipt.paymentType] ?? receipt.paymentType}</TableCell>
      {showEet && (
        <TableCell className="hidden md:table-cell">
          <EetStatusBadge submission={eetSubmission} showPok={false} />
        </TableCell>
      )}
      <TableCell className="text-right">
        <Money amount={receiptTotal(receipt)} currency={receiptCurrency(receipt)} />
        {showEet && (
          <div className="mt-0.5 md:hidden">
            <EetStatusBadge submission={eetSubmission} showPok={false} />
          </div>
        )}
      </TableCell>
      <TableCell className="hidden text-right md:table-cell">
        <ChevronRight className="ml-auto size-4 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" />
      </TableCell>
    </TableRow>
  )
}
